import {SidebarToggle} from './SidebarToggle'
import styles from './HeaderToggleOnly.module.css'

/**
 * Minimal header component that only renders the SidebarToggle without any header styling or semantic structure.
 */
export function HeaderToggleOnly() {
  return (
    <div className={styles.headerToggleOnly}>
      <SidebarToggle />
    </div>
  )
}
